@if (reviewsToDisplay() && reviewSummary()) {
  <h2 class="text-2xl font-bold mb-5">Omdömen från patienter</h2>

  <div class="flex flex-col gap-8">
    @if (reviewSummary().rating > 0) {
      <div class="flex flex-row justify-start items-center gap-5">
        <div class="flex flex-col justify-start items-start basis-1/4">
          <div class="flex flex-row items-baseline gap-1">
            <app-ui-icon
              [name]="'star_filled'"
              [size]="'md'"
              color="var(--yellow)"
            ></app-ui-icon>
            <div class="text-3xl font-bold">{{ overalRatingRounded() }}</div>
            <div class="text-sm text-grey-3">/5</div>
          </div>
          <div class="text-sm text-grey-3 pl-0.5">
            {{ reviewSummary().reviews }} {{ pluralReviews() }}
          </div>
        </div>

        <div class="w-[1px] bg-grey-8 h-full min-h-20"></div>

        <div class="flex justify-between items-end grow gap-3">
          <div class="flex grow text-right flex-col">
            @for (question of reviewSummary().reviewQuestions; track question.id) {
              <div class="text-sm text-grey-0 whitespace-nowrap">{{ question.name }}</div>
            }
          </div>
          <div class="flex basis-2/5 flex-col">
            @for (question of reviewSummary().reviewQuestions; track question.id) {
              <div class="flex w-full h-5 items-center justify-center">
                <app-line-rating
                  [rate]="question.rating"
                  class="w-full"
                ></app-line-rating>
              </div>
            }
          </div>
        </div>

      </div>
    }


    <app-ui-button (click)="createRating()" [color]="'green'" [expanded]="'block'" [size]="'md'">
      <app-ui-icon name="rating_list"></app-ui-icon>
      Lämna omdöme
    </app-ui-button>

    <div *ngIf="reviewsToDisplay() && reviewsToDisplay().length > 0" class="flex flex-col gap-8">
      @for (reviewItem of reviewsToDisplay(); let i = $index; track reviewItem.id) {
        <div
          (afterRender)="onAfterRender()"
          appAfterRender
          class="flex flex-col gap-3">

          <div class="flex flex-col justify-start">
            <div class="flex flex-row gap-1 justify-start items-baseline">
              @if (reviewItem.average >= 1) {
                <app-ui-icon
                  [name]="'star_filled'"
                  [size]="'sm'"
                  color="var(--yellow)"
                ></app-ui-icon>
                <div class="font-bold text-grey-0">
                  {{ reviewItem.average }}
                </div>
                <div class="text-grey-0">&bull;</div>
              }

              <div class="font-bold text-grey-0">
                {{ reviewItem.author }}
              </div>
            </div>
            <div class="text-sm text-grey-1 text-left">{{ reviewItem.dateCreatedFormatted }}</div>
          </div>
          @if (reviewItem.customerReviewComment !== null || reviewItem.comment !== null) {
            <div class="text-grey-0 text-base flex flex-col gap-2">
              @if (reviewItem.comment !== null) {
                <div [id]="'reviewComment-' + i"
                     class="line-clamp-3">{{ reviewItem.comment }}
                </div>
              }

              <div class="hidden"></div>
              @if (reviewItem.customerReviewComment !== null) {
                <div [id]="'reviewReply-' + i"
                     class="hidden text-base pl-4">
                  <div class="text-grey-0">
                    {{ reviewItem.customerReviewComment.createdOn }}
                    <div class="font-bold inline">{{ name() }}</div>
                    svarade:
                  </div>
                  <div class="text-base text-grey-2 italic">
                    {{ reviewItem.customerReviewComment.comment }}
                  </div>
                </div>
              }

              @if (isMoreVisible()[i] === true) {
                <div (click)="reviewMoreClick(i)"
                     [id]="'reviewMore-' + i"
                     class="cursor-pointer underline">Läs mer
                </div>
              }
            </div>
          }

        </div>
      }

    </div>

    @if (hasNextPage()) {
      <app-ui-button (click)="moreClick()"
                  [color]="'outline-tertiary'"
                  [expanded]="'block'"
                  [size]="'md'">
        Se fler omdömen
      </app-ui-button>
    }

  </div>
}

